import { useGeolocation } from "@vueuse/core";
import { Position } from "geojson";
import { defineStore } from "pinia";
import { ref, watch } from "vue";

export const useUserPosition = defineStore("userPosition", () => {
	const hasUserInteracted = ref(false);

	const { coords, resume, pause } = useGeolocation({
		enableHighAccuracy: true,
		immediate: false,
	});

	const position = ref<Position>();

	watch(
		[() => coords.value.longitude, () => coords.value.latitude],
		([long, lat]) => {
			if (long && lat && Number.isFinite(long) && Number.isFinite(lat)) {
				position.value = [long, lat];
			}
		},
	);

	function enableGeolocation() {
		if (hasUserInteracted.value) {
			return;
		}
		hasUserInteracted.value = true;
		pause();
		resume();
	}

	return {
		position: position,
		enableGeolocation,
	};
});
